import { useContext } from "react";
import { PageNewState, DesignInfoInputDialogContext } from ".";

export const useDesignInfoInputDialogState = () => {
  const { pageState, setPageState } = useContext(DesignInfoInputDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
